import React from 'react';
import { Skeleton, Box } from '@mui/material';


const DonutChartSkeleton = ({ size = 250, thickness = 90 }) => {
  return (
    <Box sx={{ width: size, height: size, position: 'relative' }}>
      <Skeleton variant="circular" width={size} height={size} className="donut_outer-circle" />
      <Skeleton
        variant="circular"
        width={size - thickness}
        height={size - thickness}
        className="donut_inner-circle"
      />
    </Box>
  );
};

export default DonutChartSkeleton;
